import { CountryCode, parsePhoneNumber } from "libphonenumber-js";
import countries from "countries-phone-masks";
import { Country, PhoneInputValue } from "../types";
import { getUserISO } from "./getUserISO";

const countriesMasks = countries as unknown as Country[];

const userCountry = countriesMasks.find((item) => getUserISO() === item.iso);

export const customerPhoneStringToInputValue = (
  phoneStr = ""
): PhoneInputValue => {
  let iso: string;
  let code: string;
  let phone: string;
  let phoneNumber;

  let defaultCountry: CountryCode | undefined;
  if (phoneStr.startsWith("1") || phoneStr.startsWith("+1")) {
    defaultCountry = "US";
  } else if (phoneStr.startsWith("91") || phoneStr.startsWith("+91")) {
    defaultCountry = "IN";
  } else {
    defaultCountry =
      (countriesMasks.find((item) =>
        phoneStr.replace("+", "").startsWith(item.code.replace("+", ""))
      )?.iso as CountryCode) || (userCountry?.iso as CountryCode);
  }
  const phoneWithPlus = phoneStr?.startsWith("+")
    ? phoneStr
    : `+${phoneStr || ""}`;

  // Check if the input contains commas (format: "US,+1,1234567890")
  if (phoneStr?.includes(",")) {
    [iso, code, phone] = phoneStr.split(",");
    try {
      phoneNumber = parsePhoneNumber(`${code}${phone}`, iso as CountryCode);
    } catch {
      //
    }
  } else {
    // Handle plain phone number string (e.g., "1123123123" or "+11123123123")
    try {
      // Determine default country based on prefix
      phoneNumber = parsePhoneNumber(phoneWithPlus, defaultCountry);

      if (phoneNumber) {
        iso = phoneNumber.country || defaultCountry || "IN";
        code = `+${phoneNumber.countryCallingCode}`;
        phone = phoneNumber.nationalNumber;
      } else {
        throw new Error("Invalid phone number");
      }
    } catch {
      iso = defaultCountry || "IN";
      code =
        (countriesMasks.find((item) => item.iso === defaultCountry)
          ?.code as CountryCode) || "+91";
      phone =
        code && phoneWithPlus.startsWith(code)
          ? phoneWithPlus.substring(code.length)
          : phoneStr;
    }
  }

  return {
    iso,
    code,
    phone,
    isValid: /000\d\d\d\d000/g.test(phone) || phoneNumber?.isValid() || false,
  };
};
